import React, {useEffect} from 'react';
import {Text} from 'react-aria-components';
import {useParams} from "react-router-dom";
import api from "../../utils/api";
import apiClient from "../../utils/api";
import JSONPretty from 'react-json-pretty';

function DatabaseConfigDebug() {
    const [config, setConfig] = React.useState(null)
    const {id} = useParams()

    useEffect(() => {
        api.getDatabaseConfiguration(id).then(data => {
            setConfig(data)
        })
    }, []);

    if (config === undefined) {
        return <Text>Loading...</Text>
    }

    return <JSONPretty id="json-pretty" data={config}></JSONPretty>
}


export default DatabaseConfigDebug

